import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=20d7d6cc&shadow"
import script from "./Widget.vue?vue&type=script&lang=js&shadow"
export * from "./Widget.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Widget.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports